<template>
  <Modal
    v-model="openForm"
    title="上传附件"
    footer-hide
    width="300"
    @on-cancel="cliclCancelBtn"
  >
    <div class="pic_question clearfloat" id="vm">
      <input
        @change="fileChange($event)"
        type="file"
        id="upload_file"
        multiple
        hidden
        accept=".png, .jpg, .jpeg, .jpeg, image/png, image/jpg, image/jpeg, image/gif"
      />
      <ul class="img-list clearfloat">
        <li v-for="(url, index) in imgList" :key="index">
          <Icon
            class="del"
            type="md-close-circle"
            @click.stop="delImg(index)"
          />
          <img :src="url.file.src" />
        </li>
      </ul>
      <div class="add-image" @click="open" v-if="mode">
        <Icon type="ios-add" />
      </div>

      <!-- <button @click="getImg">获取数据</button> -->
    </div>
    <div style="widht: 100%; margin-top: 20px" class="clearfloat">
      <div style="float: right">
        <Button type="primary" @click="uploadAnnex">立即上传</Button>
      </div>
    </div>
  </Modal>
</template>
<script>
import axios from "axios";
export default {
  props: ["isOne"],
  data() {
    return {
      imgList: [],
      size: 0,
      limit: 6, //限制图片上传的数量
      tempImgs: [],
      isCamera: true,
      mode: true,
      openForm: false,
      id: "",
      url:''
    };
  },
  methods: {
    open(v,url) {
      this.url=url;
      this.id = v.id;
      this.openForm = true;
      document.getElementById("upload_file").click();
    },
    fileChange(el) {
      if (!el.target.files[0].size) return;
      this.fileList(el.target);
      el.target.value = "";
    },
    fileList(fileList) {
      let files = fileList.files;
      for (let i = 0; i < files.length; i++) {
        //判断是否为文件夹
        if (files[i].type != "") {
          this.fileAdd(files[i]);
        } else {
          //文件夹处理
          this.folders(fileList.items[i]);
        }
      }
    },
    // 文件夹处理
    folders(files) {
      let _this = this;
      //判断是否为原生file
      if (files.kind) {
        files = files.webkitGetAsEntry();
      }
      files.createReader().readEntries(function (file) {
        for (let i = 0; i < file.length; i++) {
          if (file[i].isFile) {
            _this.foldersAdd(file[i]);
          } else {
            _this.folders(file[i]);
          }
        }
      });
    },
    foldersAdd(entry) {
      let _this = this;
      entry.file(function (file) {
        _this.fileAdd(file);
      });
    },
    fileAdd(file) {
      if (this.limit !== undefined) this.limit--;
      if (this.limit !== undefined && this.limit < 0) return;
      //总大小
      this.size = this.size + file.size;
      //判断是否为图片文件
      if (file.type.indexOf("image") == -1) {
        this.$dialog.toast({ mes: "请选择图片文件" });
      } else {
        let reader = new FileReader();
        let image = new Image();
        let _this = this;
        reader.readAsDataURL(file);
        reader.onload = function () {
          file.src = this.result;
          image.onload = function () {
            let width = image.width;
            let height = image.height;
            file.width = width;
            file.height = height;
            _this.imgList.push({
              file,
            });
          };
          image.src = file.src;
        };
      }
    },
    // 删除图片
    delImg(index) {
      this.size = this.size - this.imgList[index].file.size; //总大小
      this.imgList.splice(index, 1);
      if (this.limit !== undefined) this.limit = 6 - this.imgList.length;
    },
    getImg() {
      console.log(this.imgList);
    },
    cliclCancelBtn() {
      this.reset();
    },
    uploadAnnex() {
      let params = new window.FormData();
      if (this.imgList.length > 0) {
        if (this.imgList[0].file.size > 1024 * 1024 * 10) {
          this.$Message.error({
            content: "图片大小超过10M，请压缩后重新上传",
            duration: 2,
          });
          return;
        } else {
          params.append("id", this.id);
          params.append("proofFile", this.imgList[0].file);
        }
      }

      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: this.url,
        data: params,
      }).then((res) => {
        console.log(res);
        this.$Spin.hide(); //关闭加载
        if (res) {
          this.openForm = false;
          this.$emit("ok");
          this.reset();
        }
      });
    },
    reset() {
      this.imgList = [];
    },
  },
  watch: {
    imgList(v) {
      this.$emit("imgList", this.imgList);
      console.log(v);
      if (this.isOne) {
        if (v.length == 0) {
          this.mode = true;
        } else {
          this.mode = false;
        }
      } else {
        this.mode = true;
      }
    },
  },
};
</script>
<style>
/* 拍照 上传图片--------------------------------- */
.pic_question {
  padding: 0 0.48rem;
}

.add-image {
  float: left;
  width: 60px;
  height: 60px;
  font-size: 60px;
  color: #868686;
  position: relative;
  border: 1px solid #7a7a7a;
  text-align: center;
  line-height: 2.8rem;
  font-weight: lighter;
}

.img-list {
  flex-wrap: wrap;
  float: left;
}

.img-list > li {
  width: 60px;
  height: 60px;
  position: relative;
  margin-right: 10px;
  margin-bottom: 10px;
  display: inline-block;
}
.img-list > li .del {
  position: absolute;
  top: -8px;
  right: -4px;
  color: #2c2c2c;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  opacity: 0.5;
  font-size: 24px;
}
.img-list > li > img {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/common/photo.vue